"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _alertModule = _interopRequireDefault(require("./alert.module.css"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStyleFromVariant = function getStyleFromVariant(variant) {
  if (variant === "error") {
    return _alertModule.default["alert-danger"];
  }

  if (variant === "success") {
    return _alertModule.default["alert-success"];
  }

  if (variant === "info") {
    return _alertModule.default["alert-info"];
  }

  if (variant === "warning") {
    return _alertModule.default["alert-warning"];
  }

  if (variant === "secondaryWarning") {
    return _alertModule.default["alert-secondary-warning"];
  }

  if (variant === "tertiaryWarning") {
    return _alertModule.default["alert-tertiary-warning"];
  }

  return "";
};

var Alert = function Alert(props) {
  var id = props.id,
      variant = props.variant,
      label = props.label,
      onDismiss = props.onDismiss,
      _props$alertTestId = props.alertTestId,
      alertTestId = _props$alertTestId === void 0 ? 'alert-box' : _props$alertTestId;
  var mappedStyleFromVariant = getStyleFromVariant(variant);
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: "".concat(_themeModule.default.arag, " ").concat(_alertModule.default["alert"], " ").concat(_alertModule.default["alert-dismissible"], " ").concat(mappedStyleFromVariant),
    "data-testid": alertTestId
  }, onDismiss && _react.default.createElement("button", {
    id: id ? "".concat(id, "_btn") : null,
    type: "button",
    className: _alertModule.default["close"],
    "data-dismiss": "alert",
    onClick: onDismiss
  }, "\xD7"), _react.default.createElement("p", {
    className: "mb-0",
    id: id ? "".concat(id, "_label") : null
  }, _react.default.createElement("small", null), label));
};

Alert.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** string text that will be displayed */
  label: _propTypes.default.string,

  /** Callback that will be call invoked on close button press */
  onDismiss: _propTypes.default.func,

  /** The variant of the alert button you want */
  variant: _propTypes.default.oneOf(['success', 'error', 'info', 'warning', 'secondaryWarning', 'tertiaryWarning']),

  /**Test ID for alert */
  alertTestId: _propTypes.default.string
};
var _default = Alert;
exports.default = _default;